import { AppState } from "../../store";

export const getClaimStatusList = (state: AppState) => state.reducer.WarrantyClaim.claimStatusList;
export const getFaultTypeList = (state: AppState) => state.reducer.WarrantyClaim.claimFaultTypeList;
export const getCauseCodeList = (state: AppState) => state.reducer.WarrantyClaim.claimCauseCodeList;
export const getClaimLookupsLoaded = (state: AppState) => state.reducer.WarrantyClaim.lookupsLoaded;

export const getClaimStatusFilterOptions = (state: AppState) => [...state.reducer.WarrantyClaim.claimStatusList, {name: "Not Closed", value: "NC"}];